// extracted by mini-css-extract-plugin
module.exports = {"titleStyles":"styles_titleStyles__1Fd3h","tipColor":"styles_tipColor__2fVg0"};